module.exports = __webpack_public_path__ + "static/media/home.37a06ac7.png";